import { render, staticRenderFns } from "./_ROPCForm.vue?vue&type=template&id=389b1cea&scoped=true&"
import script from "./_ROPCForm.vue?vue&type=script&lang=ts&"
export * from "./_ROPCForm.vue?vue&type=script&lang=ts&"
import style0 from "./_ROPCForm.vue?vue&type=style&index=0&id=389b1cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b1cea",
  null
  
)

export default component.exports